export default "__VITE_PUBLIC_ASSET__e886ec3d__"